import { motion } from "framer-motion";
import {
  TrendingUp,
  Briefcase,
  Mic,
  Sparkles,
  Layers,
  Award,
} from "lucide-react";

const OUTCOMES = [
  { icon: TrendingUp, title: "Learn High-Income Skills", desc: "Master practical, in-demand skills used by working professionals." },
  { icon: Award, title: "Build a Professional Portfolio", desc: "Ship real projects that prove your value to employers and clients." },
  { icon: Briefcase, title: "Start Freelancing", desc: "Land your first paying clients with positioning and pricing that works." },
  { icon: Mic, title: "Create Content That Grows", desc: "Build an audience across reels, shorts and long-form formats." },
  { icon: Sparkles, title: "Master AI Tools", desc: "Use AI as your unfair advantage — prompts, automations, agents." },
  { icon: Layers, title: "Build Multiple Income Streams", desc: "Freelancing, content, products, services — stack income streams." },
];

export default function LearningOutcomes() {
  return (
    <section
      id="outcomes"
      data-testid="section-outcomes"
      className="py-14 sm:py-20"
    >
      <div className="max-w-7xl mx-auto px-6 sm:px-8 lg:px-12">
        <div className="text-center max-w-2xl mx-auto">
          <span className="text-[11px] uppercase tracking-[0.24em] text-[#2563EB] dark:text-[#06B6D4] font-semibold">
            Learning Outcomes
          </span>
          <h2 className="font-display mt-4 text-4xl sm:text-5xl tracking-tighter font-semibold text-[#0F172A] dark:text-white text-balance">
            What Will You Achieve?
          </h2>
          <p className="mt-5 text-slate-600 dark:text-slate-300">
            Six tangible outcomes designed to move you from learning to earning.
          </p>
        </div>

        <motion.div
          initial="hidden"
          whileInView="show"
          viewport={{ once: true, margin: "-80px" }}
          variants={{ hidden: {}, show: { transition: { staggerChildren: 0.06 } } }}
          className="mt-10 grid sm:grid-cols-2 lg:grid-cols-3 gap-5"
        >
          {OUTCOMES.map((o) => {
            const Icon = o.icon;
            return (
              <motion.div
                key={o.title}
                data-testid={`outcome-${o.title.toLowerCase().replace(/\s+/g, "-")}`}
                variants={{
                  hidden: { opacity: 0, y: 18 },
                  show: { opacity: 1, y: 0, transition: { duration: 0.45 } },
                }}
                className="rounded-3xl border border-slate-200/80 dark:border-white/10 bg-white dark:bg-white/[0.04] p-8 hairline"
              >
                <span className="inline-flex h-11 w-11 items-center justify-center rounded-2xl bg-[#2563EB]/10 text-[#2563EB] dark:bg-[#06B6D4]/10 dark:text-[#06B6D4]">
                  <Icon className="h-5 w-5" />
                </span>
                <h3 className="mt-6 font-display text-xl font-medium tracking-tight text-[#0F172A] dark:text-white">
                  {o.title}
                </h3>
                <p className="mt-2 text-[15px] leading-relaxed text-slate-600 dark:text-slate-400">
                  {o.desc}
                </p>
              </motion.div>
            );
          })}
        </motion.div>
      </div>
    </section>
  );
}
